import useRequest from '@space-shell/common/hooks/useRequest'
import { CommunitiesEndpoints, CommunitiesService } from '@space-shell/common/services/communities'

export const useGetCommunity = (communityId?: number) => {
  const {
    data: communityData,
    isInitialLoading: isLoadingCommunityData,
    invalidate: invalidateCommunityData
  } = useRequest(
    [CommunitiesEndpoints.getCommunity(Number(communityId))],
    () => CommunitiesService.getCommunity(communityId),
    { enabled: Boolean(communityId) }
  )

  return {
    communityData,
    isLoadingCommunityData,
    invalidateCommunityData
  }
}
